'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInputMask = require('react-input-mask');

var _reactInputMask2 = _interopRequireDefault(_reactInputMask);

var _mobxReact = require('mobx-react');

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _input = require('./styled/input');

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledInputMask = _input2.default.withComponent(function (_ref) {
  var error = _ref.error,
      p = (0, _objectWithoutProperties3.default)(_ref, ['error']);
  return _react2.default.createElement(_reactInputMask2.default, p);
});

var BaseInput = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(BaseInput, _Component);

  function BaseInput() {
    (0, _classCallCheck3.default)(this, BaseInput);
    return (0, _possibleConstructorReturn3.default)(this, (BaseInput.__proto__ || (0, _getPrototypeOf2.default)(BaseInput)).apply(this, arguments));
  }

  (0, _createClass3.default)(BaseInput, [{
    key: 'render',
    value: function render() {
      var attrs = (0, _extends3.default)({
        'aria-invalid': this.props.webformElement.isValid() ? null : true,
        'aria-required': this.props.state.required ? true : null
      }, this.props.field['#attributes'] || {});

      var InputComponent = _input2.default; // Input HTML element is 'input' by default

      // When there is a mask from Drupal.
      if (this.props.field['#mask']) {
        InputComponent = StyledInputMask; // Use InputMask element instead.
        attrs.mask = this.props.field['#mask'];
        attrs.alwaysShowMask = this.props.field['#alwaysShowMask'] || true;
      }

      return _react2.default.createElement(InputComponent, (0, _extends3.default)({
        type: this.props.type,
        value: this.props.value,
        name: this.props.field['#webform_key'],
        id: this.props.id || this.props.field['#webform_key'],
        placeholder: this.props.field['#placeholder'],
        error: !this.props.webformElement.isValid(),
        className: this.props.className,
        min: this.props.field['#min'],
        max: this.props.field['#max'],
        step: this.props.field['#step'],
        onChange: this.props.onChange,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown,
        ref: this.props.parentRef,
        disabled: !this.props.state.enabled,
        required: this.props.state.required
      }, attrs));
    }
  }]);
  return BaseInput;
}(_react.Component), _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#type': _propTypes2.default.string.isRequired,
    '#placeholder': _propTypes2.default.string,
    '#field_prefix': _propTypes2.default.string,
    '#field_suffix': _propTypes2.default.string,
    '#webform_key': _propTypes2.default.string.isRequired,
    '#required': _propTypes2.default.bool,
    '#mask': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    '#alwaysShowMask': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    '#min': _propTypes2.default.string,
    '#max': _propTypes2.default.string,
    '#step': _propTypes2.default.string,
    '#attributes': _propTypes2.default.oneOfType([_propTypes2.default.shape({
      autoComplete: _propTypes2.default.string
    }), _propTypes2.default.array])
  }).isRequired,
  className: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  type: _propTypes2.default.string,
  id: _propTypes2.default.number,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  parentRef: _propTypes2.default.func,
  state: _propTypes2.default.shape({
    required: _propTypes2.default.bool.isRequired,
    enabled: _propTypes2.default.bool.isRequired
  }).isRequired
}, _class2.defaultProps = {
  id: 0,
  className: undefined,
  type: 'text',
  autoComplete: '',
  onFocus: function onFocus() {},
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  parentRef: function parentRef() {}
}, _temp)) || _class;

exports.default = BaseInput;